import Vue from 'vue'
import Vuex from 'vuex'
import quiz from './modules/quiz'
import {SET_FULL_LOADER_COMMON} from './types'

Vue.use(Vuex)

const state = {
  loader: true
}

const mutations = {
  [SET_FULL_LOADER_COMMON] (state, data) {
    if (!data) {
      setTimeout(function () {
        state.loader = data
      }, 300)
    } else {
      state.loader = data
    }
  }
}

const actions = {
}

const getters = {
  fullLoaderCommon () {
    return state.loader
  }
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    quiz
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js